// v2/hooks/useMedia.js — CSS media query'yi React durumuna cevirir
import { useEffect, useState } from 'react';

export default function useMedia(sorgu) {
  const oku = () => (typeof window !== 'undefined' && window.matchMedia
    ? window.matchMedia(sorgu).matches
    : false);
  const [eslesti, setEslesti] = useState(oku);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mq = window.matchMedia(sorgu);
    const guncelle = () => setEslesti(mq.matches);
    guncelle();
    if (mq.addEventListener) mq.addEventListener('change', guncelle);
    else mq.addListener(guncelle);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', guncelle);
      else mq.removeListener(guncelle);
    };
  }, [sorgu]);

  return eslesti;
}
